import React, { useEffect } from "react";
import { apiCall } from "./aiservice";
import { aiServiceBaseUrl } from "../aiComponent";
import ReactMarkdown from "react-markdown";
import Chunk from "./chunk";
import { useChat } from "./aiContext";
import remarkGfm from 'remark-gfm'

export type SearchExampleType = {
    text: string;
}

type SuggestionType = {
    suggestions: string[];
}

export default function Conversation() {

    const [currentSearchExamples, setCurrentSearchExamples] = React.useState<SearchExampleType[]>();
    const [pendingFetchSuggestions, setPendingFetchSuggestions] = React.useState<boolean>(false);
    const [currentSuggestions, setCurrentSuggestions] = React.useState<SuggestionType>();

    const { handleSend, aiContent, currentConversation, setLoading } = useChat();

    // when content is fetched
    useEffect(()=>{
        if(!!aiContent){
            const searchExamplesArr = [] as SearchExampleType[]; 
            aiContent?.searchExamples?.map((searchExample)=>{
                searchExamplesArr.push({text: searchExample});
            });
            !!searchExamplesArr && setCurrentSearchExamples(searchExamplesArr);
        }
    },[aiContent]);

    // when no conversation is set, reset suggestions
    useEffect(()=>{
        if(!currentConversation){
            setCurrentSuggestions(undefined);
        }else{
            callGetSuggestion();
        }
    },[currentConversation]);

    // GetSuggestion
    function callGetSuggestion(){
        if(!currentConversation){
            return;
        }
        const getSuggestionBody = {
            conversationId: currentConversation?.Id
        };
        if(!!currentConversation){
            setPendingFetchSuggestions(true);
        }
        apiCall(aiServiceBaseUrl + "/getsuggestion", "POST", getSuggestionBody)
        .then((data) => {
            if (!!data) {
                try{
                    const response = JSON.parse(data) as { data: SuggestionType }
                    if(!!response){
                        setCurrentSuggestions(response.data);
                    }
                }catch(e){
                    console.warn(e);
                }
            }
        })
        .catch(error => console.error(error))
        .finally(()=>{
            setPendingFetchSuggestions(false);
        });
    }

    function doMainSearch(query: string) {
        handleSend(query);
    }

    function getInitials(name: string | undefined): string {
        try{
            if(name === undefined){
                return "";
            }
            // Split the name into an array of words
            const words = name.split(' ');
            
            // Map the words array to their first letters, convert them to uppercase
            const initials = words.map(word => word.charAt(0).toUpperCase());
            
            // Return the first two initials joined together
            const returnString = initials.slice(0, 2).join('');
            return returnString;
        }catch(e){
            console.warn("tried to parse the users initials, but got an error: ", e);
            return "";
        }
    }

    return (
        <div className={`ai-modal__presentation ${!currentConversation ? 'newConversation' : ''}`}>
        <div className={`ai-modal__presentation-content`}>
            <div className="top">
                {!currentConversation && (
                    <div className="presentation-main">
                        <h1>{aiContent?.aiHeader}</h1>
                        <h2 className="intro">{aiContent?.aiSubHeader}</h2>
                        <p>{aiContent?.description}</p>
                        {!!currentSearchExamples && (
                            <div className="searchExampleWrapper">
                            {currentSearchExamples?.map((searchExample, i)=>{
                                return (<div key={i}
                                    className="searchExample"
                                    tabIndex={0}
                                    onKeyUp={(e)=>{e.key === "Enter" && doMainSearch(searchExample.text)}}
                                    onClick={()=> doMainSearch(searchExample.text)}>
                                    <span>{searchExample.text}</span>
                                </div>);
                            })}
                        </div>
                    )}
                    </div>
                )}
                <div className="presentation-main">
                    {!!currentConversation && currentConversation?.Posts?.map((post)=>{
                        return <div key={JSON.stringify(post)} className={`${post.Role}`}>
                            {post.Role === 'user' ? <div className={`imageContainer--user`}>{getInitials(aiContent?.userName)}</div> : <img className="imageContainer--assistant" src={aiContent?.aiAssistantProfilePicture} alt="faronline AI assistant"/>}
                            <div className="presentation-text" id={currentConversation?.Id + post.CreatedDate}>
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.Content}</ReactMarkdown>
                            </div>

                            {!!post?.Sources && (
                                <div className="presentation-links">
                                    <ul className="presentation-list">
                                        {post.Sources?.map((source)=>{
                                            if(source.Chunks){
                                                
                                            
                                            var firstChunk = source.Chunks[0];
                                            return (<div key={JSON.stringify(source)}>
                                                    {
                                                            <div key={JSON.stringify(firstChunk)}>
                                                                {!!firstChunk?.ChunkId && <Chunk id={firstChunk.ChunkId} indexName={firstChunk.Index ? firstChunk.Index : (source.Type === "external" && source.IndexName === "20250218") || (source.Type === "internal" && source.IndexName === "20250304") ? source.IndexName : undefined} />}
                                                            </div>
                                                    }
                                                </div>
                                                )
                                            }
                                            }
                                            )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    })}
                </div>
            </div>
            <div className="bottom">
                <div className="suggestionWrapper">
                    {pendingFetchSuggestions ? (
                        <span className="blocker__loader"/>
                    ) : 
                    !!currentSuggestions?.suggestions && currentSuggestions.suggestions?.length > 0 && 
                        <ul className="suggestions">
                            {currentSuggestions.suggestions?.map((suggestion, i)=>{                                            
                                return <li key={i} onClick={() => doMainSearch(suggestion)}><span tabIndex={0} onKeyUp={(e)=> { e.key === "Enter" && doMainSearch(suggestion)}}>{suggestion}</span></li>
                            })}
                        </ul>
                    }
                </div>
            </div>
        </div>
    </div>
    );
}